import { createFileRoute, Outlet } from '@tanstack/react-router';
import { requireSession } from '../../auth/require-session.js';
import { SessionError, SessionPending } from '../../auth/SessionStates.js';

/** `/sheets` (1.AC-2): the layout of the stat-block form, guarded as `/` is. */
export const Route = createFileRoute('/sheets')({
  beforeLoad: async ({ location }) => ({ me: await requireSession(location.pathname) }),
  pendingComponent: SessionPending,
  pendingMs: 0,
  pendingMinMs: 0,
  errorComponent: SessionError,
  staticData: { crumb: 'Stat block' },
  component: Outlet,
});
